var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Checkmark"),React.createElement("path",{"d":"M4.96014 13.5005L0 8.60738L2.04241 6.59258L4.96014 9.47087L13.9576 0.500488L16 2.5153L4.96014 13.5005Z","fill":"url(#paint0_linear_916_6541)","key":1}),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"id":"paint0_linear_916_6541","x1":"0","y1":"0.500488","x2":"12.7247","y2":"16.1617","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#73B81D","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#16B2B0","key":1})]))]);
}

CheckmarkInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","role":"img"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
